export default __webpack_public_path__ + "static/media/MISlogo.764aa20b.png";